import ReactSelect, { components } from 'react-select';
import { Image } from '@/shared/ui/image';

import { WRAPPER } from '@/shared/styles/themes';
import styled from 'styled-components';

export const ImageControl = styled(Image)`
  margin-right: 8px;
  object-fit: cover;
`;
export const OptionWrapper = styled.div`
  display: flex;
  padding: 8px 12px 8px 8px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 8px;
  margin-bottom: 2px;
  position: relative;
  color: #afafaf;
  cursor: pointer;
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 16.8px */
  ${({ $isSelected }) =>
    $isSelected &&
    `
    border-radius: 5px;
    background: #27262B;
    color: #EDEFF5;
`}

  &:hover {
    background: #625a63;
  }
`;

export const OptionCheck = styled.div`
  position: absolute;
  right: 12px;
  top: 10px;
`;

export const Wrapper = styled.div`
  ${WRAPPER}
  display:flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 0;

  @media (max-width: 768px) {
    justify-content: center;
    margin-top: 0px;
    margin: 0;
  }
`;

export const Select = styled(ReactSelect)`
    width:100%;
  .currency-select__menu {
    border-radius: 8px;
    margin-top: 4px;
    border-radius: 8px;
    min-width:${(props) => (props.$minWidth ? '100px' : '240px')};
    overflow: hidden;
    // background: #27262B;
    background: #4b444c;
    box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.08) inset;
    z-index: 100;
    
  }
  .currency-select__menu-list {
    padding: 6px;
    max-height: fit-content;
  }

    }
    .currency-select__menu-list {
        padding: 6px;
        max-height: fit-content;
    }

    .currency-select__control {
        border-radius: 8px;
        cursor: pointer;
        padding: 5px 16px;
        color: #afafaf;
        background: #4b444c;

        @media (max-width: 768px) {
            padding: 5px 16px;
        }

        ${({ $isFocused }) =>
          $isFocused &&
          `
    border-radius: 1000px;
    background:#27262B;    
    box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.08) inset;
`}

        ${({ $profileMode }) =>
          $profileMode &&
          `
    border-radius: 8px;
  `}
  
  }

`;
